/** @module csi/table/FilmStripGroupController */
define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		/**
		 * @override
		 * Set view group settings
		 */
		_onAction: function() {
			this.widget.set("groupSettings", {key1: this.actionValue, expand1: true});
		},

		/**
		 * @override
		 * Redraw view
		 */
		postProcessSuccess: function() {
			return this.widget.refreshWidget();
		}
	});
});